import { createAction } from "redux-starter-kit";
import {
  TITLE_LIST_START_LOAD,
  TITLE_LIST_END_LOAD,
  TITLE_LIST_LOAD_FAIL,
  TITLE_LIST_FILTER_KEYWORD_ENTERED,
  TITLE_LIST_DEL_START,
  TITLE_LIST_START_CREATE,
  TITLE_LIST_END_CREATE,
  TITLE_LIST_SHOW_CREATE,
  TITLE_LIST_HIDE_CREATE,
  TITLE_LIST_EDIT_TITLE,
  TITLE_LIST_EDIT_TITLE_START_LOAD,
  TITLE_LIST_EDIT_TITLE_END_LOAD,
  TITLE_LIST_EDIT_TITLE_COMPLETE,
  TITLE_LIST_RECOVER_TITLE
} from "../actionTypes";
import {
  getTitlesApi,
  delTitleApi,
  createTitleApi,
  editTitleApi
} from "../../api/titles";

export const startLoadTitlesAction = createAction(TITLE_LIST_START_LOAD);
export const endLoadTitlesAction = createAction(TITLE_LIST_END_LOAD);
export const titlesFailLoadAction = createAction(TITLE_LIST_LOAD_FAIL);
export const filterKeywordEnteredAction = createAction(
  TITLE_LIST_FILTER_KEYWORD_ENTERED
);
export const delTitleStartAction = createAction(TITLE_LIST_DEL_START);
export const startCreateAction = createAction(TITLE_LIST_START_CREATE);
export const endCreateAction = createAction(TITLE_LIST_END_CREATE);
export const showCreateAction = createAction(TITLE_LIST_SHOW_CREATE);
export const hideCreateAction = createAction(TITLE_LIST_HIDE_CREATE);
export const editTitleAction = createAction(TITLE_LIST_EDIT_TITLE);
export const editTitleStartLoadAction = createAction(
  TITLE_LIST_EDIT_TITLE_START_LOAD
);
export const editTitleEndLoadAction = createAction(
  TITLE_LIST_EDIT_TITLE_END_LOAD
);
export const editTitleCompleteAction = createAction(
  TITLE_LIST_EDIT_TITLE_COMPLETE
);
export const recoverTitlesAction = createAction(TITLE_LIST_RECOVER_TITLE);

export function loadTitleRequestAction() {
  return async dispatch => {
    dispatch(startLoadTitlesAction());

    try {
      let titles = await getTitlesApi();

      dispatch(endLoadTitlesAction({ titles }));
    } catch (e) {
      dispatch(titlesFailLoadAction({ errMsg: e.toString() }));
    }
  };
}

export function delTitleRequestAction(aTitle, allTitles, toast) {
  return async dispatch => {
    const titleID = aTitle.id;

    dispatch(delTitleStartAction({ titleID }));

    try {
      await delTitleApi(titleID);
    } catch (e) {
      dispatch(recoverTitlesAction({ allTitles: allTitles }));
      toast.error(e.toString());
    }
  };
}

export function createTitleRequestAction(title, prodTitle, toast) {
  return async dispatch => {
    dispatch(startCreateAction());

    try {
      await createTitleApi(title, prodTitle);

      dispatch(endCreateAction());
      dispatch(hideCreateAction());
      dispatch(loadTitleRequestAction());
    } catch (e) {
      dispatch(endCreateAction());
      toast.error(e.toString());
    }
  };
}

export function editTitleRequestAction(id, newName, toast) {
  return async dispatch => {
    dispatch(editTitleStartLoadAction());

    try {
      await editTitleApi(id, newName);

      dispatch(editTitleEndLoadAction());
      dispatch(editTitleAction({ edittingTitleID: null }));
      dispatch(editTitleCompleteAction({ id: id, newName: newName }));
    } catch (e) {
      dispatch(editTitleEndLoadAction());
      toast.error(e.toString());
    }
  };
}
